import 'css-chunk:../../src/features/curvature-combs/components/show-curvature-combs-options-button/index.module.scss';export default {
  "pad_slight": "_pad_slight_rj8y4_1"
};